import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link, Routes, Route, Navigate } from "react-router-dom";
import { GetScheduleSyncEvent } from "../../../store/ScheduleSync/ScheduleSyncEventAction";
import RenderTabs from "../../misc/Tabs";
import ScheduleSyncEventMembers from "./ScheduleSyncEventMembers";
import ScheduleSyncEventTrackings from "./ScheduleSyncEventTrackings";
import ScheduleSyncEventInfo from './ScheduleSyncEventInfo';
import { ScheduleSync_CoreEvent } from "../../../models/CoreScheduleSyncModels";
import { RequestState } from "../../../models/RequestState";
import StatusCode from "../../../util/StatusCode";
import Loading from "../../misc/Loading";
import * as Tab from '../../../util/TabValue';
import NotFound from '../../administration/components/NotFound';
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";



const ScheduleSyncEvent = () => {
    const { t } = useTranslation(['common']);

    const { eventId } = useParams();
    const dispatch = useDispatch();
    const event = useSelector<RootState, RequestState<ScheduleSync_CoreEvent>>(state => state.schedulesync_events.event);

    useEffect(() => {
        if (eventId) {
            GetScheduleSyncEvent(eventId)(dispatch);
        }
    }, [dispatch, eventId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.Members,
        Tab.Tabs.Trackings,
    ];

    if (eventId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/schedulesync/event">{t('object.scheduleSync.calendarEvent', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (event.code) {
        case StatusCode.COMPLETE:
            displayName = event.data.title;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={eventId}
                    url="schedulesync/event" />

                <Suspense>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<ScheduleSyncEventInfo />} />
                        <Route path={Tab.Tabs.Members.url} element={<ScheduleSyncEventMembers />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<ScheduleSyncEventTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/schedulesync/event/${eventId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (event.error.response?.status === 404 || event.error.response?.status === 400) {
                return <NotFound
                    header={t('object.scheduleSync.calendarEvent', { ns: 'common', count: 1 })}
                    translateKey={{ i18nKey: "notFound.event", ns: "scheduleSync" }}
                    link="/schedulesync/event"
                />
            } else {
                return renderContent(<p>{event.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default ScheduleSyncEvent;
